/* M71 LTD theme */
(function () {
  'use strict';

  var counts = document.querySelectorAll('[data-cart-count]');
  function setCount(n) {
    counts.forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
  }
  setCount(parseInt(counts.length ? counts[0].textContent : '0', 10) || 0);

  document.querySelectorAll('[data-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-id');
      if (!id) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          setCount(cart.item_count);
          btn.textContent = 'Added';
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
        })
        .catch(function () {
          btn.textContent = 'Try again';
          btn.disabled = false;
        });
    });
  });

  var toggle = document.querySelector('[data-menu-toggle]');
  var mobile = document.getElementById('mobile-nav');
  if (toggle && mobile) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      mobile.hidden = open;
    });
  }

  var select = document.querySelector('.pdp__select');
  if (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var add = document.querySelector('.pdp__add');
      if (add) add.disabled = opt.disabled;
    });
  }
})();

// Tick-box filters on the Computers and technology collection
(function () {
  var box = document.querySelector('[data-filters]');
  if (!box) return;
  var items = document.querySelectorAll('[data-filter-grid] .filter-item');
  var empty = document.querySelector('[data-filter-empty]');
  function apply() {
    var on = Array.prototype.map.call(box.querySelectorAll('input:checked'), function (i) { return i.value; });
    var shown = 0;
    items.forEach(function (el) {
      var show = on.indexOf(el.getAttribute('data-type')) !== -1;
      el.classList.toggle('is-hidden', !show);
      if (show) shown++;
    });
    if (empty) empty.hidden = shown > 0;
  }
  box.addEventListener('change', apply);
  apply();
})();
